<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['student_bursary'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button
                  v-b-modal.new-feesexemption
                  size="sm"
                  variant="primary"
                  ><i class="mdi mdi-plus"></i> New Fees Exemption</b-button
                >
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Found</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(student_id)="data">
                    <b class="text-danger">{{
                      data.item.student.student_id
                    }}</b>
                    <br />
                  </template>
                  <template #cell(student)="data">
                    {{ data.item.student.first_name }}
                    {{ data.item.student.last_name }}
                  </template>
                  <template #cell(term)="data">
                    {{ data.item.term.name }} - {{ data.item.year }}
                  </template>
                  <template #cell(amount)="data">
                    {{ commas(data.item.amount) }}
                  </template>
                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <b-button
                        @click="
                          edit(
                            data.item.id,
                            data.item.student.student_id,
                            data.item.term.id,
                            data.item.year,
                            data.item.amount,
                            data.item.reason,
                          )
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="primary"
                        v-b-modal.edit
                      >
                        <i class="mdi mdi-square-edit-outline"></i>
                      </b-button>
                      <b-button
                        @click="remove(data.item.id, data.item.student)"
                        type="button"
                        class="btn-sm btn"
                        variant="danger"
                        v-b-modal.delete
                      >
                        <i class="mdi mdi-trash-can"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="new-feesexemption"
        centered
        title="New Fees Exemption"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="addFeesExemption">
          <div class="form-group mb-2">
            <label
              >Student :
              <small class="text-primary">{{
                student.student_id
              }}</small></label
            >

            <multiselect
              v-model="student"
              :options="students"
              placeholder="Select Student"
              :custom-label="customLabel"
            >
            </multiselect>
            <label>Term</label>
            <multiselect
              v-model="schoolterm"
              label="name"
              :options="schoolterms"
            ></multiselect>
            <label>Year</label>
            <b-form-input v-model="year" type="number"></b-form-input>
            <label>Amount</label>
            <b-form-input v-model="amount" type="number"></b-form-input>
            <label>Reason</label>
            <textarea v-model="reason" rows="2" class="form-control"></textarea>
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('new-feesexemption')"
              >Close</b-button
            >
            <b-button
              type="submit"
              class="btn ms-1 w-30"
              variant="primary"
              :disabled="loader"
            >
              <b-spinner
                v-if="loader"
                small
                class="mr-1"
                label="Small Spinner"
              /><i v-else class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="edit-feesexemption"
        centered
        title="Edit Fees Exemption"
        title-class="font-14"
        hide-footer
      >
        <form @submit.prevent="editFeesExemption">
          <div class="form-group mb-2">
            <input v-model="id" type="hidden" />
            <label
              >Student :
              <small class="text-primary">{{ student }}</small></label
            >
            <v-select
              :options="students"
              placeholder="Select Student"
              v-model="student"
              :reduce="(students) => students.student.student_id"
            >
              <template slot="option" slot-scope="option">
                <div>
                  {{ option.student.first_name }}
                  {{ option.student.last_name }} {{ option.class.name }}
                  {{ option.stream.name }}
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div>
                  {{ option.student.first_name }}
                  {{ option.student.last_name }} {{ option.class.name }}
                  {{ option.stream.name }}
                </div>
              </template>
            </v-select>
            <label>Term</label>
            <v-select
              :options="schoolterms"
              placeholder="Select Term"
              v-model="schoolterm"
              label="name"
              :reduce="(schoolterms) => schoolterms.id"
            ></v-select>
            <label>Year</label>
            <b-form-input v-model="year" type="number"></b-form-input>
            <label>Amount</label>
            <b-form-input v-model="amount" type="number"></b-form-input>
            <label>Reason</label>
            <textarea v-model="reason" rows="2" class="form-control"></textarea>
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('edit-feesexemption')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-feesexemption"
        centered
        title="Delete Fees Exemption"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeFeesExemption">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the Fees Exemption for : <br /><b
            >{{ student }}
          </b>
          ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-feesexemption')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  studentMethods,
  studentComputed,
  feesExemptionComputed,
  feesExemptionMethods,
  schooltermMethods,
  schooltermComputed,
} from "@/state/helpers";

export default {
  page: {
    title: "Fees Exemptions",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Fees Exemptions",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Fees Exemptions", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "student_id", label: "Student ID", visible: true },
        { key: "student", label: "Student", visible: true },
        { key: "term", label: "Term", visible: true },
        { key: "amount", label: "Amount", visible: true },
        { key: "reason", label: "Reason", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      userData: JSON.parse(localStorage.getItem("user")),
      id: "",
      student: "",
      schoolterm: "",
      year: new Date().getFullYear(),
      amount: "",
      reason: "",
      loader: false,
    };
  },
  computed: {
    ...schooltermComputed,
    ...feesExemptionComputed,
    ...studentComputed,
    List() {
      return this.feesexemptions.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.feesexemptions.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.feesexemptions.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchSchoolTerms();
    this.fetchStudents();
    this.fetchFeesExemptions();
    this.TotalRows = this.feesexemptions.length;
    this.isBusy = false;
    // this.schoolterm = this.schoolterms.find(option => option.active == 1);
  },
  methods: {
    ...schooltermMethods,
    ...studentMethods,
    ...feesExemptionMethods,
    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    customLabel(student) {
      return `${student.student.first_name} ${student.student.last_name} ${student.class.name} ${student.stream.name} `;
    },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id, student, schoolterm, year, amount, reason) {
      this.id = id;
      this.student = student;
      this.schoolterm = schoolterm;
      this.year = year;
      this.amount = amount;
      this.reason = reason;
      this.$bvModal.show("edit-feesexemption");
    },
    remove(id, student) {
      this.id = id;
      this.student = student.first_name + " " + student.last_name;
      this.$bvModal.show("delete-feesexemption");
    },
    async addFeesExemption() {
      this.loader = true;
      let formData = new FormData();
      // formData.append("student", this.student);
      formData.append("student", this.student.student.student_id);

      formData.append("schoolterm", this.schoolterm.id);
      formData.append("year", this.year);
      formData.append("amount", this.amount);
      formData.append("reason", this.reason);
      let url = "/addfeesexemption";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchFeesExemptions();
          this.$bvModal.hide("new-feesexemption");
          this.student = "";
          this.amount = "";
          this.year = "";
          this.schoolterm = "";
          this.reason = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
          this.loader = false;
        }
      });
    },
    async editFeesExemption() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("student", this.student);
      formData.append("schoolterm", this.schoolterm);
      formData.append("year", this.year);
      formData.append("amount", this.amount);
      formData.append("reason", this.reason);
      let url = "/updatefeesexemption";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchFeesExemptions();
          this.$bvModal.hide("edit-feesexemption");
          this.student = "";
          this.amount = "";
          this.year = "";
          this.schoolterm = "";
          this.reason = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async removeFeesExemption() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removefeesexemption";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchFeesExemptions();
          this.$bvModal.hide("delete-feesexemption");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
  },
};
</script>
